export default function preview({ query, enablePreview }) {
  if (query._storyblok) {
    enablePreview();
  }
}
